<template>
    <AppModal
        ref="modalRef"
        v-model="isVisible"
        size="xl"
        v-if="roleId"
    >
        <template #header>
            <h3 class="modal-title">
                {{ $t("View Role Permissions") }}
            </h3>
        </template>

        <template #default>
           <RoleDisplay :role-id="roleId" />
        </template>

        <template #footer>
            <AppButton btnClass="btn-white" @click="closeModal">
                <AppIcon :icon="faClose" />
                {{ $t("Close") }}
            </AppButton>
        </template>
    </AppModal>
</template>

<script setup lang="ts">
import { nextTick, ref } from "vue";
import AppModal from "@/vue/shared/AppModal.vue";
import AppButton from "@/vue/shared/AppButton.vue";
import AppIcon from "@/vue/shared/AppIcon.vue";
import { trans as $t } from "laravel-vue-i18n";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import RoleDisplay from "@/vue/support/role/RoleDisplay.vue";

const isVisible = defineModel<boolean>({ default: false });
const modalRef = ref<any>(null);

const props = defineProps({
    roleId: {
        type: Number,
        required: true
    }
});

const closeModal = () => nextTick(modalRef.value?.closeModal);

</script>